import { forwardRef } from 'react';
import { cn } from '@/utils/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  isError?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className, isError, ...props }, ref) => {
  return (
    <input
      ref={ref}
      {...props}
      className={cn(
        'h-[38px] w-full px-[12px] text-[#4B4B4B] text-[14px] border border-[#D9D9D9] rounded-[8px] outline-hidden focus:border-[#0C8DBF] focus-within:border-[#0C8DBF]',
        isError && 'focus:border-[#CC0202] focus-within:border-[#CC0202] border-[#CC0202]',
        className
      )}
    />
  );
});

Input.displayName = 'Input';

export default Input;
